import {
  useState, useEffect, useCallback, useRef,
} from 'react';
import { APIGetAssetCompliance } from '../../../config/restAPI/FetchAPI';
import {
  isApiResponseNotFound,
  parseApiObjectResponse,
} from './maintenanceComplianceUtils';

export function useAssetCompliance(assetId, token, agencyID) {
  const [compliance, setCompliance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const assetIdRef = useRef(assetId);

  useEffect(() => {
    assetIdRef.current = assetId;
  }, [assetId]);

  const refetch = useCallback(async () => {
    if (!assetId || !token || !agencyID) return;
    const requestAssetId = assetId;
    setError('');
    setLoading(true);
    try {
      const result = await APIGetAssetCompliance(() => {}, token, agencyID, assetId);
      if (requestAssetId !== assetIdRef.current) return;
      if (isApiResponseNotFound(result)) {
        setCompliance(null);
        return;
      }
      const data = parseApiObjectResponse(result);
      if (requestAssetId !== assetIdRef.current) return;
      if (data) {
        setCompliance(data);
      } else {
        setError('Unable to load vehicle compliance.');
      }
    } catch {
      if (requestAssetId === assetIdRef.current) {
        setError('Unable to load vehicle compliance.');
      }
    } finally {
      if (requestAssetId === assetIdRef.current) {
        setLoading(false);
      }
    }
  }, [assetId, token, agencyID]);

  useEffect(() => {
    setCompliance(null);
    setError('');
    setLoading(Boolean(assetId));
  }, [assetId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    compliance,
    loading,
    error,
    refetch,
  };
}
